import React, { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from 'react-redux';
import { toggleAdminMode } from "../redux/slices/adminModeSlice";
import { ReactComponent as SettingsIcon } from "../assets/settings.svg";
import { ReactComponent as SvgWeightLoss } from "../assets/lessWeight.svg";
import { ReactComponent as SvgMuscleGain } from "../assets/muscul.svg";
import { ReactComponent as SvgBodyRecomp } from "../assets/BodyRecomp.svg";
import { ReactComponent as SvgUndecided } from "../assets/idk.svg";
import config from "../config.js";
import { ReactComponent as ArrowDownIcon } from "../assets/arrow-down.svg";
import { ReactComponent as PenIcon } from "../assets/pen.svg";
import { ReactComponent as AccessIcon } from "../assets/access.svg";
import { ReactComponent as Ico1 } from "../assets/toprof/ico1.svg";
import { ReactComponent as Ico2 } from "../assets/toprof/ico4.svg";
import { ReactComponent as Ico3 } from "../assets/toprof/ico3.svg";
import { ReactComponent as Ico4 } from "../assets/toprof/ico2.svg";


const Profile = () => {
    const genderOptions = ["Мужской", "Женский"];
    const goalOptions = [
        "Студент",
        "Фрилансер",
        "Продаю свои услуги",
        "Предприниматель",
        "Рабтаю по найму",
        "Не работаю не учусь"
    ];
    const [isGenderOpen, setIsGenderOpen] = useState(false);
    const [isGoalOpen, setIsGoalOpen] = useState(false);
    const [isGoal2Open, setIsGoal2Open] = useState(false);
    const initData = window.Telegram.WebApp.initData;
    const [userInfo, setUserData] = useState({
        name: "Неизвестен",
        birthDate: "",
        gender: "",
        goal1: "",
        goal2: "",
        aboutMe: "",
        financialGoal: "",
        avatar: "",
    });
    const [editMode, setEditMode] = useState(false);
    const dispatch = useDispatch();
    const isSuperUser = useSelector((state) => state.isAdmin.isSuperUser);  // Проверяем, является ли пользователь администратором
    const adminMode = useSelector((state) => state.adminMode.adminMode); // Проверяем состояние режима администратора

    const assetsOptions = [
        "Дом",
        "Машина",
        "Бизнес",
        "Смартфон",
        "Ноутбук",
    ];

    const incomeOptions = [
        "До 30 000₽",
        "30 000₽ - 60000₽",
        "60 000₽ - 100 000₽",
        "100 000₽ - 200 000₽",
        "200 000₽ - 500 000₽",
        "500 000₽ - 1 000 000₽",
        "1 000 000₽ +"
    ];

    const nextOptions = [
        "100 000₽ - 300 000₽",
        "300 000₽ - 500 000₽",
        "500 000₽ - 1 000 000₽",
        "1 000 000₽ - 2 000 000₽",
        "2 000 000₽ - 5 000 000₽",
        "5 000 000₽ +"
    ];

    const [isAssetsStartOpen, setIsAssetsStartOpen] = useState(false);
    const [isIncomeStartOpen, setIsIncomeStartOpen] = useState(false);

    const [startPoint, setStartPoint] = useState({
        weight: 70,
        assets: "",
        income: "",
        condition: 5
    });

    const [isAssetsTargetOpen, setIsAssetsTargetOpen] = useState(false);
    const [isIncomeTargetOpen, setIsIncomeTargetOpen] = useState(false);

    const [targetPoint, setTargetPoint] = useState({
        weight: 70,
        assets: "",
        income: "",
        condition: 5
    });

    const adjustValue = (point, field, increment) => {
        const setter = point === 'start' ? setStartPoint : setTargetPoint;
        const value = point === 'start' ? startPoint[field] : targetPoint[field];

        if (field === 'weight') {
            setter(prev => ({ ...prev, [field]: Math.max(30, Math.min(200, value + increment)) }));
        } else if (field === 'condition') {
            setter(prev => ({ ...prev, [field]: Math.max(1, Math.min(10, value + increment)) }));
        }
    };

    const adjustTextareaHeight = (e) => {
        const textarea = e.target;
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    };

    useEffect(() => {
        if (window.Telegram && window.Telegram.WebApp) {
            const { photo_url } = window.Telegram.WebApp.initDataUnsafe?.user || {};
            setUserData((prev) => ({ ...prev, avatar: photo_url || "" }));
        }
        axios.post(`${config.API_BASE_URL}/profile/get`, { initData })
            .then((res) => {
                setUserData((prev) => ({ ...prev, ...res.data.data }));
                const data = res.data.data;
                if (data.startPoint) setStartPoint(data.startPoint);
                if (data.targetPoint) setTargetPoint(data.targetPoint);
            })
            .catch(() => console.log("Ошибка загрузки профиля"));
    }, [initData]);

    const saveProfile = () => {
        // Собираем все данные для отправки
        const profileData = {
            ...userInfo,
            startPoint: {
                weight: parseInt(startPoint.weight),
                assets: startPoint.assets,
                income: startPoint.income,
                condition: parseInt(startPoint.condition)
            },
            targetPoint: {
                weight: parseInt(targetPoint.weight),
                assets: targetPoint.assets,
                income: targetPoint.income,
                condition: parseInt(targetPoint.condition)
            }
        };

        axios.post(`${config.API_BASE_URL}/profile/save`, {
            initData,
            userInfo: profileData
        })
            .then(() => setEditMode(false))
            .catch(() => console.log("Ошибка сохранения"));
    };

    const getAgeInYears = (birthDate) => {
        const birth = new Date(birthDate);
        const today = new Date();
        let age = today.getFullYear() - birth.getFullYear();
        const m = today.getMonth() - birth.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
            age--;
        }

        // Логика для падежа
        const getCorrectForm = (age) => {
            if (age % 10 === 1 && age % 100 !== 11) {
                return "год";  // Например, 1 год
            } else if ((age % 10 >= 2 && age % 10 <= 4) && (age % 100 < 10 || age % 100 >= 20)) {
                return "года";  // Например, 22 года, 23 года
            } else {
                return "лет";  // Для всех остальных случаев, например, 5 лет, 30 лет
            }
        };

        return `${age} ${getCorrectForm(age)}`;
    };

    const getGoalIcon = (goal) => {
        const goalIcons = {
            "Похудение": <SvgWeightLoss />,
            "Набор мышечной массы": <SvgMuscleGain />,
            "Рекомпозиция тела": <SvgBodyRecomp />,
            "Не определился": <SvgUndecided />,
        };

        return goalIcons[goal] || null;
    };

    const handleToggleAdminMode = () => {
        // Переключаем состояние режима администратора
        dispatch(toggleAdminMode());
    };

    const fitnessGoalOptions = [
        "Похудение",
        "Набор мышечной массы",
        "Рекомпозиция тела",
        "Не определился"
    ];

    const calculateProfileCompletion = (userInfo, startPoint, targetPoint) => {
        const fields = [
            { field: 'name', value: userInfo.name, default: "Неизвестен" },
            { field: 'birthDate', value: userInfo.birthDate },
            { field: 'gender', value: userInfo.gender },
            { field: 'goal1', value: userInfo.goal1 },
            { field: 'goal2', value: userInfo.goal2 },
            { field: 'aboutMe', value: userInfo.aboutMe },
            { field: 'financialGoal', value: userInfo.financialGoal },
            { field: 'startPoint.weight', value: startPoint.weight, default: 70 },
            { field: 'startPoint.assets', value: startPoint.assets },
            { field: 'startPoint.income', value: startPoint.income },
            { field: 'startPoint.condition', value: startPoint.condition, default: 5 },
            { field: 'targetPoint.weight', value: targetPoint.weight, default: 70 },
            { field: 'targetPoint.assets', value: targetPoint.assets },
            { field: 'targetPoint.income', value: targetPoint.income },
            { field: 'targetPoint.condition', value: targetPoint.condition, default: 5 }
        ];

        const filledFields = fields.filter(item => {
            const value = item.value;
            return value && value !== "" && value !== item.default;
        });

        return Math.round((filledFields.length / fields.length) * 100);
    };

    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        return d.toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        });
    };

    return (
        <div className="profile-container">
            <div className="profile-header">
                <h3>{editMode ? 'Настройки' : 'Профиль'}</h3>
                {/* Кнопка для переключения админского режима */}
                {isSuperUser ? (
                    <>
                        <button
                            className={`admin-mode-btn ${adminMode ? "enabled" : "disabled"}`}
                            onClick={handleToggleAdminMode}
                        >
                            {adminMode ? "Disable Admin mode" : "Enable Admin mode"}
                        </button>
                        {!editMode && (
                            <SettingsIcon
                                className="settings-icon"
                                onClick={() => setEditMode(!editMode)}
                            />
                        )}</>
                ) : (
                    !editMode && (
                        <button className="settings-btn" onClick={() => setEditMode(!editMode)}>
                            <span>Настройки</span>
                            <SettingsIcon className="settings-icon" />
                        </button>
                    )
                )}
            </div>
            <div className="profile-content">
                <div className="avatar-container">
                    <img src={userInfo.avatar} alt="Аватар" className="avatar" />
                    <div className="avatar-name">{userInfo.name}, {userInfo.birthDate && (
                        getAgeInYears(userInfo.birthDate)
                    )}</div>
                    {!editMode && userInfo.aboutMe && (
                        <>
                            <div className="avatar-about">{userInfo.aboutMe}</div>
                            <div className="profile-completion">
                                <div className="completion-bar">
                                    <div
                                        className="completion-progress"
                                        style={{ width: `${calculateProfileCompletion(userInfo, startPoint, targetPoint)}%` }}
                                    />
                                    <div className="completion-text">
                                        <span className="label">Профиль</span>
                                        <span className="percentage">{calculateProfileCompletion(userInfo, startPoint, targetPoint)}%</span>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                {editMode ? (
                    <div className="edit-mode">
                        <div className="edit-section">
                            <h4>Ваше имя</h4>
                            <div className="input-wrapper">
                                <input
                                    className="input-field"
                                    type="text"
                                    value={userInfo.name}
                                    onChange={(e) => setUserData({ ...userInfo, name: e.target.value })}
                                    placeholder="Имя"
                                />
                                <PenIcon className="field-icon" />
                            </div>
                        </div>

                        <div className="edit-section">
                            <h4>Дата рождения</h4>
                            <div className="input-wrapper">
                                <input
                                    className="input-field"
                                    type="date"
                                    value={userInfo.birthDate}
                                    onChange={(e) => setUserData({ ...userInfo, birthDate: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="edit-section">
                            <h4>Ваш пол</h4>
                            <div className="dropdown">
                                <div className="dropdown-header" onClick={() => setIsGenderOpen(!isGenderOpen)}>
                                    {userInfo.gender || "Выберите пол"}
                                    <ArrowDownIcon className={`arrow-icon ${isGenderOpen ? 'up' : ''}`} />
                                </div>
                                {isGenderOpen && (
                                    <ul className="dropdown-list">
                                        {genderOptions.map((option) => (
                                            <li key={option} onClick={() => {
                                                setUserData({ ...userInfo, gender: option });
                                                setIsGenderOpen(false);
                                            }}>
                                                {option}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>

                        <div className="edit-section">
                            <h4>Род деятельности</h4>
                            <div className="dropdown">
                                <div className="dropdown-header" onClick={() => setIsGoalOpen(!isGoalOpen)}>
                                    {userInfo.goal1 || "Выберите род деятельности"}
                                    <ArrowDownIcon className={`arrow-icon ${isGoalOpen ? 'up' : ''}`} />
                                </div>
                                {isGoalOpen && (
                                    <ul className="dropdown-list">
                                        {goalOptions.map((option) => (
                                            <li key={option} onClick={() => {
                                                setUserData({ ...userInfo, goal1: option });
                                                setIsGoalOpen(false);
                                            }}>
                                                {option}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>

                        <div className="edit-section">
                            <h4>Фитнес цель</h4>
                            <div className="dropdown">
                                <div className="dropdown-header" onClick={() => setIsGoal2Open(!isGoal2Open)}>
                                    {getGoalIcon(userInfo.goal2)}
                                    {userInfo.goal2 || "Выберите фитнес цель"}
                                    <ArrowDownIcon className={`arrow-icon ${isGoal2Open ? 'up' : ''}`} />
                                </div>
                                {isGoal2Open && (
                                    <ul className="dropdown-list">
                                        {fitnessGoalOptions.map((option) => (
                                            <li key={option} onClick={() => {
                                                setUserData({ ...userInfo, goal2: option });
                                                setIsGoal2Open(false);
                                            }}>
                                                {getGoalIcon(option)}
                                                {option}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>

                        <div className="edit-section">
                            <h4>Обо мне</h4>
                            <div className="input-wrapper">
                                <textarea
                                    className="textarea-field"
                                    value={userInfo.aboutMe}
                                    onChange={(e) => {
                                        setUserData({ ...userInfo, aboutMe: e.target.value });
                                        adjustTextareaHeight(e);
                                    }}
                                    onInput={adjustTextareaHeight}
                                    placeholder="Расскажите о себе"
                                />
                                <PenIcon className="field-icon" />
                            </div>
                        </div>

                        <div className="edit-section">
                            <h4>Финансовая цель</h4>
                            <div className="input-wrapper">
                                <textarea
                                    className="textarea-field"
                                    value={userInfo.financialGoal}
                                    onChange={(e) => {
                                        setUserData({ ...userInfo, financialGoal: e.target.value });
                                        adjustTextareaHeight(e);
                                    }}
                                    onInput={adjustTextareaHeight}
                                    placeholder="Опишите вашу финансовую цель"
                                />
                                <PenIcon className="field-icon" />
                            </div>
                        </div>

                        <div className="point-section">
                            <h3 className="point-title">ТОЧКА А: СЕЙЧАС</h3>

                            <div className="edit-section">
                                <h4>
                                    Вес
                                    <span className="current-value">
                                        {startPoint.weight === 40 ? "менее 40" :
                                            startPoint.weight === 150 ? "более 150" :
                                                `${startPoint.weight} кг`}
                                    </span>
                                </h4>
                                <div className="slider-container">
                                    <button onClick={() => adjustValue('start', 'weight', -1)}>-</button>
                                    <input
                                        type="range"
                                        min="40"
                                        max="150"
                                        value={startPoint.weight}
                                        onChange={(e) => {
                                            const value = parseInt(e.target.value);
                                            setStartPoint(prev => ({ ...prev, weight: value }));
                                        }}
                                    />
                                    <button onClick={() => adjustValue('start', 'weight', 1)}>+</button>
                                </div>
                            </div>

                            <div className="edit-section">
                                <h4>Активы</h4>
                                <div className="dropdown">
                                    <div className="dropdown-header" onClick={() => setIsAssetsStartOpen(!isAssetsStartOpen)}>
                                        {startPoint.assets || "Выберите диапазон"}
                                        <ArrowDownIcon className={`arrow-icon ${isAssetsStartOpen ? 'up' : ''}`} />
                                    </div>
                                    {isAssetsStartOpen && (
                                        <ul className="dropdown-list">
                                            {assetsOptions.map((option) => (
                                                <li key={option} onClick={() => {
                                                    setStartPoint(prev => ({ ...prev, assets: option }));
                                                    setIsAssetsStartOpen(false);
                                                }}>
                                                    {option}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <div className="edit-section">
                                <h4>Уровень дохода</h4>
                                <div className="dropdown">
                                    <div className="dropdown-header" onClick={() => setIsIncomeStartOpen(!isIncomeStartOpen)}>
                                        {startPoint.income || "Выберите диапазон"}
                                        <ArrowDownIcon className={`arrow-icon ${isIncomeStartOpen ? 'up' : ''}`} />
                                    </div>
                                    {isIncomeStartOpen && (
                                        <ul className="dropdown-list">
                                            {incomeOptions.map((option) => (
                                                <li key={option} onClick={() => {
                                                    setStartPoint(prev => ({ ...prev, income: option }));
                                                    setIsIncomeStartOpen(false);
                                                }}>
                                                    {option}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <div className="edit-section">
                                <h4>
                                    Состояние
                                    <span className="current-value">
                                        {startPoint.condition === 1 ? "очень плохо" :
                                            startPoint.condition === 10 ? "отлично" :
                                                `${startPoint.condition}/10`}
                                    </span>
                                </h4>
                                <div className="slider-container">
                                    <button onClick={() => adjustValue('start', 'condition', -1)}>-</button>
                                    <input
                                        type="range"
                                        min="1"
                                        max="10"
                                        value={startPoint.condition}
                                        onChange={(e) => setStartPoint(prev => ({
                                            ...prev,
                                            condition: parseInt(e.target.value)
                                        }))}
                                    />
                                    <button onClick={() => adjustValue('start', 'condition', 1)}>+</button>
                                </div>
                            </div>
                        </div>

                        <div className="point-section">
                            <h3 className="point-title">ТОЧКА Б: ЦЕЛЬ</h3>

                            <div className="edit-section">
                                <h4>
                                    Вес
                                    <span className="current-value">
                                        {targetPoint.weight === 40 ? "менее 40" :
                                            targetPoint.weight === 150 ? "более 150" :
                                                `${targetPoint.weight} кг`}
                                    </span>
                                </h4>
                                <div className="slider-container">
                                    <button onClick={() => adjustValue('target', 'weight', -1)}>-</button>
                                    <input
                                        type="range"
                                        min="40"
                                        max="150"
                                        value={targetPoint.weight}
                                        onChange={(e) => {
                                            const value = parseInt(e.target.value);
                                            setTargetPoint(prev => ({ ...prev, weight: value }));
                                        }}
                                    />
                                    <button onClick={() => adjustValue('target', 'weight', 1)}>+</button>
                                </div>
                            </div>

                            <div className="edit-section">
                                <h4>Активы</h4>
                                <div className="dropdown">
                                    <div className="dropdown-header" onClick={() => setIsAssetsTargetOpen(!isAssetsTargetOpen)}>
                                        {targetPoint.assets || "Выберите диапазон"}
                                        <ArrowDownIcon className={`arrow-icon ${isAssetsTargetOpen ? 'up' : ''}`} />
                                    </div>
                                    {isAssetsTargetOpen && (
                                        <ul className="dropdown-list">
                                            {assetsOptions.map((option) => (
                                                <li key={option} onClick={() => {
                                                    setTargetPoint(prev => ({ ...prev, assets: option }));
                                                    setIsAssetsTargetOpen(false);
                                                }}>
                                                    {option}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <div className="edit-section">
                                <h4>Уровень дохода</h4>
                                <div className="dropdown">
                                    <div className="dropdown-header" onClick={() => setIsIncomeTargetOpen(!isIncomeTargetOpen)}>
                                        {targetPoint.income || "Выберите диапазон"}
                                        <ArrowDownIcon className={`arrow-icon ${isIncomeTargetOpen ? 'up' : ''}`} />
                                    </div>
                                    {isIncomeTargetOpen && (
                                        <ul className="dropdown-list">
                                            {nextOptions.map((option) => (
                                                <li key={option} onClick={() => {
                                                    setTargetPoint(prev => ({ ...prev, income: option }));
                                                    setIsIncomeTargetOpen(false);
                                                }}>
                                                    {option}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <div className="edit-section">
                                <h4>
                                    Состояние
                                    <span className="current-value">
                                        {targetPoint.condition === 1 ? "очень плохо" :
                                            targetPoint.condition === 10 ? "отлично" :
                                                `${targetPoint.condition}/10`}
                                    </span>
                                </h4>
                                <div className="slider-container">
                                    <button onClick={() => adjustValue('target', 'condition', -1)}>-</button>
                                    <input
                                        type="range"
                                        min="1"
                                        max="10"
                                        value={targetPoint.condition}
                                        onChange={(e) => setTargetPoint(prev => ({
                                            ...prev,
                                            condition: parseInt(e.target.value)
                                        }))}
                                    />
                                    <button onClick={() => adjustValue('target', 'condition', 1)}>+</button>
                                </div>
                            </div>
                        </div>

                        <button className="save-button" onClick={saveProfile}>Сохранить</button>
                    </div>
                ) : (
                    <>
                        <div className="subscription-block">
                            <div className="subscription-info">
                                <AccessIcon className="access-icon" />
                                <div className="subscription-details">
                                    <div className="subscription-status">Доступ в клуб оплачен</div>
                                    <div className="subscription-date">До: {formatDate(userInfo.expireDate)}</div>
                                </div>
                            </div>
                            <a href="https://t.me/theolefirenkoclub_bot" className="extend-button">
                                Продлить
                            </a>
                        </div>

                        <div className="points-display">
                            <div className="point-block start-point">
                                <h4>ТОЧКА А: СЕЙЧАС</h4>
                                <div className="point-info">
                                    <div className="point-row">
                                        <div className="point-label">
                                            <div className="ico-box">
                                                <Ico1 className="point-icon" />
                                            </div>
                                            <span>Вес</span>
                                        </div>
                                        <span className="point-value">{startPoint.weight} кг</span>
                                    </div>
                                    <div className="point-row">
                                        <div className="point-label">
                                            <div className="ico-box">
                                                <Ico2 className="point-icon" />
                                            </div>
                                            <span>Активы</span>
                                        </div>
                                        <span className="point-value">{startPoint.assets || "Не указано"}</span>
                                    </div>
                                    <div className="point-row">
                                        <div className="point-label">
                                            <div className="ico-box">
                                                <Ico3 className="point-icon" />
                                            </div>
                                            <span>Уровень дохода</span>
                                        </div>
                                        <span className="point-value">{startPoint.income || "Не указано"}</span>
                                    </div>
                                    <div className="point-row">
                                        <div className="point-label">
                                            <div className="ico-box">
                                                <Ico4 className="point-icon" />
                                            </div>
                                            <span>Состояние</span>
                                        </div>
                                        <span className="point-value">{startPoint.condition}/10</span>
                                    </div>
                                </div>
                            </div>

                            <div className="point-block target-point">
                                <h4>ТОЧКА Б: ЦЕЛЬ</h4>
                                <div className="point-info">
                                    <div className="point-row">
                                        <div className="point-label">
                                            <div className="ico-box">
                                                <Ico1 className="point-icon" />
                                            </div>
                                            <span>Вес</span>
                                        </div>
                                        <span className="point-value">{targetPoint.weight} кг</span>
                                    </div>
                                    <div className="point-row">
                                        <div className="point-label">
                                            <div className="ico-box">
                                                <Ico2 className="point-icon" />
                                            </div>
                                            <span>Активы</span>
                                        </div>
                                        <span className="point-value">{targetPoint.assets || "Не указано"}</span>
                                    </div>
                                    <div className="point-row">
                                        <div className="point-label">
                                            <div className="ico-box">
                                                <Ico3 className="point-icon" />
                                            </div>
                                            <span>Уровень дохода</span>
                                        </div>
                                        <span className="point-value">{targetPoint.income || "Не указано"}</span>
                                    </div>
                                    <div className="point-row">
                                        <div className="point-label">
                                            <div className="ico-box">
                                                <Ico4 className="point-icon" />
                                            </div>
                                            <span>Состояние</span>
                                        </div>
                                        <span className="point-value">{targetPoint.condition}/10</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </>
                )}
            </div>
        </div>
    );
};

export default Profile;
